import React from 'react';

import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Rating from '@mui/material/Rating';

type PopularItem = {
	id: number;
	name: string;
	img: string;
	price: number;
	rating: number;
};

type PopularCardProps = {
	item: PopularItem;
};

function ModernCardPopular({ item }: PopularCardProps): JSX.Element {
	return (
		<Paper
			variant="outlined"
			sx={{
				width: '200px',
				padding: '0.5rem',
				textAlign: 'center',
				display: 'flex',
				alignItems: 'center',
				flexDirection: 'column',
				gap: '0.25rem',
				borderRadius: '10px',
				cursor: 'pointer',
			}}
		>
			<Typography variant="subtitle2" sx={{ color: 'var(--csmd-cl-text-primary)' }}>
				{item.name}
			</Typography>
			<Box
				component="img"
				src={item.img}
				alt={item.name}
				loading="lazy"
				width="100px"
				height="100px"
			/>

			<Box
				component="div"
				sx={{
					display: 'flex',
					justifyContent: 'space-between',
					width: '90%',
					alignItems: 'center',
				}}
			>
				<Typography sx={{ fontSize: '0.9rem', color: 'var(--csmd-cl-text-primary)' }}>
					<Typography
						component="span"
						style={{
							fontWeight: 'bold',
							color: 'var(--csmd-cl-text-primary)',
							paddingRight: '0.25rem',
						}}
					>
						$
					</Typography>
					{item.price}
				</Typography>
				<Rating name="read-only" value={item.rating} readOnly size="small" />
			</Box>
		</Paper>
	);
}

export default ModernCardPopular;
